import Immutable from "seamless-immutable";
import actions from "./actions";

const initialState = Immutable({
  isFetching: false,
  successMessage: "",
  errorMessage: "",
  actionType: "",
  status_code: 0,
  donorDetails: {},
  accessToken: "",
  refreshToken: "",
  accessTokenExpiry: 0, // Store expiry time here
});

export default function otpReducer(state = initialState, action) {
  switch (action.type) {
    case actions.OTP_REQUEST:
      return Immutable.merge(state, {
        isFetching: true,
        actionType: actions.OTP_REQUEST,
      });
    case actions.OTP_SUCCESS:
      return Immutable.merge(state, {
        isFetching: false,
        actionType: actions.OTP_SUCCESS,
        donorDetails: action.donorDetails,
        successMessage: action.successMessage,
        status_code: action.status_code,
        accessToken: action.accessToken,
        refreshToken: action.refreshToken,
        accessTokenExpiry: action.accessTokenExpiry, // Store the expiry time
      });
    case actions.OTP_ERROR:
      return Immutable.merge(state, {
        isFetching: false,
        actionType: actions.OTP_ERROR,
        errorMessage: action.errorMessage,
      });

    case actions.REFRESH_TOKEN_REQUEST:
      return Immutable.merge(state, {
        isFetching: true,
        actionType: actions.REFRESH_TOKEN_REQUEST,
      });

    case actions.REFRESH_TOKEN_SUCCESS:
      return Immutable.merge(state, {
        isFetching: false,
        actionType: actions.REFRESH_TOKEN_SUCCESS,
        accessToken: action.accessToken,
        refreshToken: action.refreshToken,
        accessTokenExpiry: action.accessTokenExpiry,
      });

    case actions.REFRESH_TOKEN_ERROR:
      return Immutable.merge(state, {
        isFetching: false,
        actionType: actions.REFRESH_TOKEN_ERROR,
        errorMessage: action.errorMessage,
      });

    case actions.RESET_ACTIONTYPE:
      return Immutable.merge(state, {
        actionType: "",
        successMessage: "",
        errorMessage: "",
        isFetching: false,
      });

    default:
      return state;
  }
}
